import React from 'react';
import SpeechBot from '../controls/speech-bot/SpeechBot';
import './VoiceChatPage.css';

function VoiceChatPage(): React.ReactElement {


  return (
    <div className="voice-chat-page">
      <div className="voice-chat-container">
        <div className="voice-chat-content">
          <SpeechBot />
        </div>
      </div>
    </div>
  );
}

export default VoiceChatPage;